import type { AdvisorUsersControllerGetDonutStatsResponse } from '@/__generated__/requests'

export enum CategorizedAssetsType {
  ASSETS = 'assets',
  DEBT = 'debt',
}

export type CategorizedAssetsProps = {
  data: AdvisorUsersControllerGetDonutStatsResponse
  type: CategorizedAssetsType
}
